import { render } from "./MyServices.vue?vue&type=template&id=d2cfc916&scoped=true"
import script from "./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue?vue&type=script&lang=js"

import "./MyServices.vue?vue&type=style&index=0&id=d2cfc916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cfc916"]])

export default __exports__